const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const currencyToText = (value: number = 0) =>
  currencyFormatter.format(value);
